import { useEffect } from "react";

/**
 * Sets the page title with optional tenant prefix
 * @param pageName - The page name (will be translated if using t() function)
 * @param tenant - Optional tenant code (nada, cada, atd)
 */
export function usePageTitle(pageName: string, tenant?: string) {
    useEffect(() => {
        const tenantPrefix = tenant ? `${tenant.toUpperCase()}: ` : "";
        document.title = `${tenantPrefix}${pageName}`;
    }, [pageName, tenant]);
}
